import useAccountExists from 'hooks/services/account/useAccountExists';
import { useDebouncedValue } from 'hooks/useDebouncedValue';

/**
 * Whether a company with the typed name already exists in Crono. The name is
 * checked once the typing pauses; until then it's still being checked.
 */
export const useCompanyNameCheck = (name: string) => {
  const trimmedName = name.trim();
  const checkedName = useDebouncedValue(trimmedName, 300);
  const { data, isFetching } = useAccountExists(checkedName, true);

  return {
    isChecking: !!trimmedName && (checkedName !== trimmedName || isFetching),
    isTaken:
      !!trimmedName && checkedName === trimmedName && !!data?.data?.data.length,
  };
};
